export const GET_CHECK_IN_CALLS = gql`
    query getCheckInCalls {
        getCheckInCalls {
            id
            createdAt
            callType
            callName
            callDescription
        }
    }
`;

export const GET_CHECK_IN_CALL = gql`
    query getCheckInCall($id: Int!) {
        getCheckInCall(id: $id) {
            id
            createdAt
            callType
            callName
            callDescription
            factorRangeEnd
            periodLength
            schedulePeriod
            recurring
            checkInType
            checkInTypeDays
        }
    }
`;

export const GET_CHECK_IN_CALLS_SUCCESS = gql`
    query getSuccessCheckInCalls {
        getSuccessCheckInCalls {
            id
            scheduleCallDate
            days
            merchantName
            serviceId
            serviceNumber
            callName
        }
    }
`;

export const GET_CHECK_IN_CALL_SUCCESS = gql`
    query getSuccessCheckInCall($id: Int!) {
        getSuccessCheckInCall(id: $id) {
            id
            scheduleCallDate
            days
            merchantName
            serviceId
            callName
        }
    }
`;

export const DELETE_CHECK_IN_CALL_SUCCESS_BY_ID = gql`
    mutation deleteSuccessCheckInCall($id: Int!) {
        deleteSuccessCheckInCall(id: $id) {
            success
            message
        }
    }
`;

export const UPDATE_CHECK_IN_CALL_SUCCESS_CALL_DATE = gql`
    mutation updateSuccessScheduledCallDate($id: Int!, $newDate: DateTime!) {
        updateSuccessScheduledCallDate(id: $id, newDate: $newDate) {
            message
            success
        }
    }
`;

export const GET_CHECK_IN_CALLS_FOR_SERVICE = gql`
    query GetCheckInCallNotesForService($serviceId: Int!) {
        getCheckInCallNotesForService(serviceId: $serviceId) {
            id
            createdAt
            subject
            body
            checkInCallSuccessServiceId
            createdBy {
                id
                firstName
                lastName
            }
        }
    }
`;

export const GET_CHECK_IN_CALLS_FOR_SERVICE_FOR_MERCHANT = gql`
    query getCheckInCallNotesForForMerchant($merchantId: Int!) {
        getCheckInCallNotesForForMerchant(merchantId: $merchantId) {
            id
            createdAt
            subject
            body
            checkInCallSuccessServiceId
            createdBy {
                id
                firstName
                lastName
            }
        }
    }
`;
